export default [{ value: 'NO', label: 'No' }, { value: 'YES', label: 'Yes' }];
